export default class Payment {
    cardNumber              = "";
    cardDataValidate        = null;
    cardCvv                 = null;
    cardCvvSize             = null;
    cardBrand               = null;
    cardToken               = null;    
    ownerFullname           = null;
    ownerDateBirth          = null;
    ownerPhone              = null;
    
    ownerCep                = null;
    ownerAddress            = null;
    ownerAddressNumber      = null;
    ownerAddressComplement  = null;
    ownerDistrict           = null;
    ownerCity               = null;
    ownerState              = null;

    ownerCpf                = null;
    installmentSelected     = null;


    constructor(){ }
}



    